export const support = {
    title: "সাপোর্ট অ্যাক্সেস",
    description: "কিছু সময়ের জন্য Sobthik সাপোর্ট টিমকে এই ব্যবসায় প্রবেশ করতে দিন, যেমন ইমপোর্টে সাহায্যের জন্য। তারা যা করে সব লগে থাকে।",
    grant: "সাপোর্ট অ্যাক্সেস দিন",
    hours: "কতক্ষণের জন্য",
    hoursOption_one: "{{hours}} ঘণ্টা",
    hoursOption_other: "{{hours}} ঘণ্টা",
    note: "কী বিষয়ে সাহায্য দরকার? (ঐচ্ছিক)",
    granted: "{{date}} পর্যন্ত সাপোর্ট সাইন ইন করতে পারবে।",
    revoke: "এখনই অ্যাক্সেস বন্ধ করুন",
    revoked: "সাপোর্ট অ্যাক্সেস বন্ধ হয়েছে।",
    history: "আগের অ্যাক্সেস",
    empty: "আপনি সাপোর্ট অ্যাক্সেস দেননি।",
    active: "{{date}} পর্যন্ত চালু",
    ended: "{{date}} বন্ধ হয়েছে",
    expired: "{{date}} মেয়াদ শেষ",
    banner: "{{date}} পর্যন্ত Sobthik সাপোর্ট এই ব্যবসায় সাইন ইন করতে পারবে।",
    manage: "পরিচালনা",
    signIn: {
        title: "সাপোর্ট সাইন-ইন",
        body: "Sobthik সাপোর্ট টিমের জন্য: সুপার অ্যাডমিন থেকে সাপোর্ট টোকেন দিন। মালিকের দেওয়া অ্যাক্সেস চালু থাকলেই এটি কাজ করে।",
        token: "সাপোর্ট টোকেন",
        submit: "ব্যবসা খুলুন",
    },
    dismiss: "বন্ধ করুন",
};
//# sourceMappingURL=support.js.map